import React, { useState, useEffect, useContext } from 'react'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import DialogBox from '../../../shared/ui/DialogBox'
import InputField from '../../../shared/ui/InputField'
import Link from '../../../shared/ui/Link'
import Button from '../../../shared/ui/Button'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'

import { withStyles } from '@material-ui/core/styles'
import { Typography, Box } from '@material-ui/core'


const styles = theme => ({

})

const CancelOrderForm = ({ theme, classes, children, onClose, onConfirm, ...props }) => {

  const navigationContext = useContext(NavigationContext)
  const [formData, setFormData] = useState({})

  const options = ['No suitable trainer', 'Too expensive']

  const onChange = (fieldName) => (value) => {
    let newFormData = {
      ...formData,
      [fieldName]: value
    }

    setFormData(newFormData)
  }

  const validateAndSave = () => {
    if (formData.cancel_reason) {
      navigationContext.showLoadingDialog(true)

      onConfirm(formData)
    } else {
      alert("You have to explain your reason.")
    }
  }

  let reasonButtons = [
    <Button variant='contained' fullWidth onClick={onClose} color="default">
      Cancel
    </Button>,
    <Button variant='contained' fullWidth onClick={validateAndSave} color="primary">
      Confirm
    </Button>
  ]

  return (
    <DialogBox show={true} onClose={onClose} title={'Cancel Reason'} actionButtons={reasonButtons}>
      <Typography variant='body1'>
        Please choose the reason when you cancel order.
      </Typography>
      <InputField 
        name='cancel_reason'
        type='option'
        value={formData.cancel_reason}
        options={options}
        onChange={onChange('cancel_reason')}
        gutterBottom
      />
    </DialogBox>
  )
}

export default withStyles(styles, { withTheme: true })(
    (CancelOrderForm)
)
